import React from 'react';
import { Link } from 'react-router-dom';


function menuInteremedioAcerca() {
  const handleClick = (seccion) => {
    alert(`Navegar a la sección: ${seccion}`);
  };

  return (
    <div style={styles.container}>    
      <div style={styles.innerContainer}>
        <Link to="/nivelinicial">
          <button style={styles.boton}>Nivel Inicial</button>
        </Link>
        <Link to="/nivelprimario">
          <button style={styles.boton}>Primario</button>
        </Link>
        <Link to="/nivelsecundario">
          <button style={styles.boton}>Secundario</button>
        </Link>
        <Link to="/InglesIntensivo">
          <button style={styles.boton}>Ingles</button>
        </Link>
      </div>
    </div>
  );
}

const styles = {
  container: {
    overflowX: 'auto',
    width: '100%',
    backgroundColor: 'white',
  },
  innerContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '1rem',
    padding: '0.5rem',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  boton: {
    padding: '0.6rem 1.2rem',
    backgroundColor: 'transparent',
    color: 'green',
    fontWeight: 'bold',
    fontSize: '1rem',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    whiteSpace: 'nowrap',
  },
};

export default menuInteremedioAcerca;
